// extracted by mini-css-extract-plugin
export default {"title":"B6-z","warning":"C6-z","sizeOptionsLegendText":"D6-z"};